import { Layout, Summary } from '@/views/configuration';

export default {
    path: '/configuration',
    component: Layout,
    children: [
        { path: 'summary', component: Summary },
    ]
};
